"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Player = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _defaultTemplate = _interopRequireDefault(require("./defaultTemplate.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _maxBy2 = _interopRequireDefault(require("lodash/maxBy"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _settings = require("./settings.js");
var _helpers = require("../../../../other/helpers.js");
var _difference_in_seconds = _interopRequireDefault(require("date-fns/difference_in_seconds"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _forkKnife = _interopRequireDefault(require("cccisd-icons/fork-knife"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Player = exports.Player = /*#__PURE__*/function (_React$Component) {
  _inherits(Player, _React$Component);
  function Player() {
    var _this;
    _classCallCheck(this, Player);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Player, [].concat(args));
    /** Check if we should advance to the next page */
    _defineProperty(_assertThisInitialized(_this), "checkAdvance", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        settings = _this$props.settings;
      if (settings.afterCompletion !== 'advance' || !children) {
        return;
      }
      var finishedChildren = children.filter(function (child) {
        return child.progress && child.progress.finishedFirst && child.progress.finishedLast;
      });
      if (settings.completeCondition === 'all' && children.length !== finishedChildren.length) {
        return;
      }
      if (settings.completeCondition === 'minimum' && finishedChildren.length !== settings.minimumNumber) {
        return;
      }
      var MIN_WAIT = 2;
      var currentFormattedGmtTime = (0, _helpers.getCurrentFormattedGmtTime)();
      var lastMenuItem = (0, _maxBy2["default"])(finishedChildren, function (child) {
        return child.progress.finishedLast;
      });
      if (lastMenuItem.progress.finishedFirst === lastMenuItem.progress.finishedLast && (0, _difference_in_seconds["default"])(currentFormattedGmtTime, lastMenuItem.progress.finishedLast) <= MIN_WAIT) {
        _this.props.goToNextPage();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getChildren", function () {
      var children = _this.props.children;
      return children.map(function (child) {
        var progressState;
        if (child.progress && child.progress.finishedFirst) {
          progressState = 'finished';
        } else if (child.progress && child.progress.startedFirst) {
          progressState = 'started';
        } else {
          progressState = 'unstarted';
        }
        return _objectSpread(_objectSpread({}, child), {}, {
          progressState: progressState
        });
      });
    });
    return _this;
  }
  _createClass(Player, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkAdvance();
    }
  }, {
    key: "render",
    value: function render() {
      var name = this.props.settings.name;
      var _this$props2 = this.props,
        isPreview = _this$props2.isPreview,
        settings = _this$props2.settings,
        accommodations = _this$props2.accommodations,
        goToComponent = _this$props2.goToComponent,
        showRequiredState = _this$props2.showRequiredState,
        showQuestionNumbers = _this$props2.showQuestionNumbers,
        startQuestionNumber = _this$props2.startQuestionNumber;
      if (isPreview) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].block
        }, /*#__PURE__*/_react["default"].createElement(_forkKnife["default"], {
          spaceRight: true
        }), name);
      }
      var elementStyle = (0, _get2["default"])(this.props, 'playerTemplateProps.playerTemplateSettings.elementStyle');
      var templateProps = _objectSpread({
        question: settings.question || settings.description ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, settings.question && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.question,
          showRequiredState: showRequiredState && settings.isRequired,
          registerAction: this.props.registerAction.bind(null, 1),
          setParameters: this.props.setParameters,
          accommodations: accommodations,
          prependWith: showQuestionNumbers && "".concat(startQuestionNumber, ". ")
        }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].description
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.description
        }))) : null,
        children: this._getChildren(),
        goToComponent: goToComponent,
        // Advanced props
        settings: settings,
        playerTemplateProps: this.props.playerTemplateProps,
        accommodations: accommodations,
        elementStyle: elementStyle
      }, this.props.templateExtraProps);
      var Template = this.props.template || _defaultTemplate["default"];
      return /*#__PURE__*/_react["default"].createElement(Template, templateProps);
    }
  }]);
  return Player;
}(_react["default"].Component);
_defineProperty(Player, "propTypes", {
  settings: _propTypes["default"].object,
  template: _propTypes["default"].func,
  templateExtraProps: _propTypes["default"].object,
  showRequiredState: _propTypes["default"].bool,
  isPreview: _propTypes["default"].bool,
  children: _propTypes["default"].array,
  goToComponent: _propTypes["default"].func,
  goToNextPage: _propTypes["default"].func,
  playerTemplateProps: _propTypes["default"].object,
  accommodations: _propTypes["default"].object
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({
  validate: _settings.validate
})(Player);